export default __webpack_public_path__ + "icon-justhatched@2x.06e51d74.png";